import Button from '@ausbom/button';
import { IProps } from '@ausbom/button/lib/Button';
import { createLink, LinkComponent } from '@tanstack/react-router';
import * as React from 'react';
import './ButtonLink.scss';

const ButtonLinkComponent = React.forwardRef<Button, IProps>((props, ref) => {
  const className = props.className ? `button-link ${props.className}` : 'button-link';
  return <Button as="a" ref={ref} {...props} className={className} />;
});

const Link = createLink(ButtonLinkComponent);

const ButtonLink: LinkComponent<typeof ButtonLinkComponent> = (props) => {
  return <Link preload={'intent'} {...props} />;
};

export default ButtonLink;
